import { mediaData } from '@/mocks/tanhua';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            精选视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            探花系列精选视频展示，高清探花作品一睹为快
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={`探花视频 - ${item.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-1 bg-background-950/75 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span className="whitespace-nowrap">{item.views} 次观看</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}